import React from 'react';
import { motion } from 'framer-motion';

import InfoCard from '../../../components/InfoCard';

import card02 from '../../../assets/images/cardbg-2.png';

export default function Introduction() {
  const containerVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const lineVariants = {
    hidden: {
      y: 50,
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  // Dividir el texto en líneas para la animación
  const textLines = [
    'Soluciona todos tus problemas legales accediendo a abogados',
    'altamente calificados a través de nuestra plataforma,',
    'de forma fácil, rápida y accesible.',
  ];

  return (
    <div className="w-full bg-white flex flex-col justify-center items-center">
      <div className="max-w-5xl w-full mx-auto px-8 flex flex-col items-center">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="text-center py-20"
        >
          <div className="text-xl md:text-2xl font-light text-gray-700 max-w-3xl mx-auto leading-relaxed tracking-wide">
            {textLines.map((line, index) => (
              <div key={index} className="overflow-hidden">
                <motion.div variants={lineVariants} className="block">
                  {line}
                </motion.div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>

      {/* CTA Section - Full Width */}
      <motion.div
        variants={itemVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        className="w-full"
      >
        <InfoCard
          backgroundImage={card02}
          text="Soluciones Legales a un Click"
          buttonText="Unete ahora"
        />
      </motion.div>
    </div>
  );
}
